import { render, staticRenderFns } from "./ActivationsList.vue?vue&type=template&id=6243c8f8&scoped=true"
import script from "./ActivationsList.vue?vue&type=script&lang=js"
export * from "./ActivationsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6243c8f8",
  null
  
)

export default component.exports